import {Component, OnInit } from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import { User } from '../../../generated/graphql';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import {QueryRef} from 'apollo-angular';
import {UserService} from "../../service/user.service";
import { Awards, RemoveAwardsInput, GetAllAwardsQuery, UpdateAwardsInput, UploadFileResponse } from 'src/app/model/award';
import { GetAllAwardsGQL, RemoveAwardGQL, CreateAwardGQL, UpdateAwardsGQL } from 'graphql/awards/awards.definition';

import Swal, { SweetAlertIcon } from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-store-management',
    templateUrl: './store-management.component.html',
    styleUrls: ['./store-management.component.scss']
})

export class StoreManagementComponent extends BaseComponent implements OnInit {
    public removeAward = new RemoveAwardsInput();
    public productsList: Awards[];
    public userRole: string;

    user: User = new User();
    allAwardsQuery: QueryRef<GetAllAwardsQuery>;
    modelAllAwards: any = {keyword: ''};

    modelAward: Awards = new Awards();
    awardInput: UpdateAwardsInput= new UpdateAwardsInput();

    awardImage: string
    imageFile: FormData
    bucketUrl: string
    newloading: boolean

    expandedImageUrl: string | null = null;

    constructor(
        public router: Router,
        public loading: NgxSpinnerService,
        public translate: TranslateService,
        public userService: UserService,
        public getAllAwardsGQL: GetAllAwardsGQL,
        public removeAwardGQL: RemoveAwardGQL,
        public createAwardGQL: CreateAwardGQL,
        public updateAwardsGQL:  UpdateAwardsGQL,
        private http: HttpClient
    ) {
        super(router, loading, translate);
    }
    getAwards(){
        this.allAwardsQuery = this.getAllAwardsGQL.watch();
        this.allAwardsQuery.valueChanges.subscribe(data=>{
            let awardList = data.data.getAllAwards;
            this.productsList = awardList.filter((awardList)=> awardList.deletedAt == null);
        });
    }
    ngOnInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;

                this.userRole = data.role;
            }, error: err => super.onError(err)
        });

        this.bucketUrl = environment.bucketUrl
    }

    showMessage(title: string, message: string, icon: SweetAlertIcon): Promise<any> {
        return new Promise((resolve) => {
          Swal.fire({
            title: title,
            html: message,
            icon: icon,
            confirmButtonColor: '#265ba3',
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
          }).then((result) => {
            resolve(result);
          });
        });
    }

    changeAward(award:Awards){
        this.modelAward = Object.assign({}, award);
        this.modelAward.image?.includes("award-files")
        ? (this.awardImage = this.bucketUrl + award.image)
        : (this.awardImage = "");
        this.showModal('modalAward');
    }

    deleteProduct(product){
        this.showMessage(this.translate.instant('storeManagement.removeProduct'), `${this.translate.instant(`storeManagement.removeProductDescription`)} ${product.name} `, 'question').then((resp)=>{
            if(resp.isConfirmed){
                this.removeAward.id = product.id;
                this.removeAward.role = this.userRole;
                
                this.removeAwardGQL.mutate({data: this.removeAward}).subscribe((resp)=>{
                    this.showMessage(this.translate.instant('storeManagement.successTitle'), this.translate.instant('storeManagement.keepManagement'), 'success');
                    setTimeout(()=>{
                        Swal.close();
                    }, 4000);

                    this.getAwards();  
                }),(err)=>{
                    this.showMessage(this.translate.instant('storeManagement.removeFailure'), err, 'error');
                    setTimeout(()=>{
                        Swal.close();
                    }, 4000);
                }
            }
        });
    }
    onImageChange(event: Event){
        const target = event.target as HTMLInputElement;
        const file: File = target.files[0];

        const formData = new FormData();
        
        formData.append('file', file);

        this.imageFile = formData

        if (file) {
            this.convertToBase64(file);
        }

        target.value = ''
    }

    onValueChange(event: any, field: string) {
        const inputValue = event.target.value;
        if (inputValue.length > 6) {
            event.target.value = inputValue.slice(0, 6);
        }
        this.modelAward[field] = parseInt(event.target.value, 10);
    }

    uploadFile(isCreatingAward?: boolean ) {
        this.http.post(`${environment.base_url}/awards/file`, this.imageFile)
        .subscribe(
            (response: UploadFileResponse) => {
                this.modelAward.image = response.fileName

                if(isCreatingAward) {
                    this.createAward()
                    return
                }

                this.updateAward()
            },
            (error: unknown) => {
                this.newloading = false
                this.onError(error);
            }
        )
    }
    
    convertToBase64(file: File): void {
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64String: string = reader.result as string;
            this.modelAward.image = base64String;
            this.awardImage = base64String;
        };

        reader.readAsDataURL(file);
    }

    actionAward(){
        this.modelAward = new Awards();
        this.showModal('modalAward');
        this.awardImage = '';
        this.modelAward.image = '';
        this.imageFile = null
    }
    actionSave(){
        if (super.isNullOrUndefined(this.modelAward.id)) {
            this.onCreateAward();
        } else {
            this.onChangeAward(this.modelAward);
        }
    }
    onCreateAward(){
        const arrValidateFields = [
            {value: this.modelAward.name, text: this.translate.instant('storeManagement.awardName') + ', <br />'},
            {value: this.modelAward.value, text: this.translate.instant('storeManagement.awardValue') + ', <br />'},
            {value: this.modelAward.quantity, text: this.translate.instant('storeManagement.awardQuantity') + ', <br />'},
            {value: this.modelAward.category, text: this.translate.instant('storeManagement.category') + ' <br />'},
          ];
          const stringError = this.validateField(arrValidateFields);
          if (!super.isNullOrUndefined(stringError)) {
            this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`, 'error');
            return;
          }

          this.newloading = true

          if (this.imageFile) {
            this.uploadFile(true)
            return
          }

          this.createAward()
    }

    createAward() {
        this.createAwardGQL.mutate({data: this.modelAward}).subscribe({
            next: () => {
                this.newloading = false
                

                this.showMessage(this.translate.instant('storeManagement.successCreateTitle'), '', 'success');
                this.closeModal('modalAward');
                this.getAwards();
            },
            error: (error) => {
                this.newloading = false
                super.onError(error)
            },
        });
    }

    ngAfterViewInit(){
        this.getAwards();
    }

    updateAward() {
        this.updateAwardsGQL.mutate(this.awardInput).subscribe({
            next: () => {
                this.newloading = false
                this.showMessage(this.translate.instant('storeManagement.successUpdateTitle'), '', 'success');
                this.closeModal('modalAward');
                this.getAwards();
            },
            error: (error) => {
                this.newloading = false
                super.onError(error);
            },
        })
    }

    onChangeAward(award: Awards){
        this.awardInput.data = award
        this.awardInput.data.role = this.userRole ? this.userRole : 'local-manager';
        delete this.awardInput.data['__typename']

        this.newloading = true

        if(this.awardInput.data.image?.includes('base64')) {
            this.uploadFile()
            return
        }

        this.updateAward()
    }

    expandImage(imageUrl: string): void {
        if(imageUrl) {
            this.expandedImageUrl = this.bucketUrl.concat(imageUrl);
        }
    }
    
    closeExpandedImage(): void {
        this.expandedImageUrl = null;
    }
}
